import {
  HIGHLIGHT,
  REMOVE,
  PREVIEW,
} from './action-names';

export const highlight = (data) => {
  return {
    type: HIGHLIGHT,
    ...data
  };
};

export const remove = (data) => {
  return {
    type: REMOVE,
    ...data
  };
};

export const preview = () => {
  return {
    type: PREVIEW
  };
};



// WEBPACK FOOTER //
// ./app/header-builder/actions/general-actions.js